/* SPC — Harness PDP (Katlyma 1:1 Mirror). */
(function () {
  var root = document.querySelector('[data-hp]');
  if (!root) return;
  var T = window.SPC_T || {};
  function tr(k, d) { return T[k] || d; }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money Formatter ---------- */
  function money(cents) {
    var n = (Math.round(cents) / 100).toFixed(2);
    var parts = n.split('.');
    var main = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return '€' + main + ',' + parts[1];
  }

  /* ---------- Gallery Slider ---------- */
  var track = root.querySelector('[data-hp-gal-track]');
  var slides = track ? track.querySelectorAll('[data-hp-slide]') : [];
  var thumbs = root.querySelectorAll('[data-hp-thumb]');
  var countEl = root.querySelector('[data-hp-count]');
  var current = 0;
  function goTo(i) {
    if (!slides.length) return;
    current = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    mark();
  }
  function mark() {
    thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === current); });
    if (countEl) countEl.textContent = current + 1;
    var active = thumbs[current];
    if (active && active.parentElement) {
      var p = active.parentElement;
      p.scrollTo({ left: active.offsetLeft - p.clientWidth / 2 + active.clientWidth / 2, behavior: 'smooth' });
    }
  }
  if (track) {
    var gt;
    track.addEventListener('scroll', function () {
      clearTimeout(gt);
      gt = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) { current = i; mark(); }
      }, 80);
    }, { passive: true });
  }
  thumbs.forEach(function (b) { b.addEventListener('click', function () { goTo(+b.dataset.hpThumb); }); });
  var prev = root.querySelector('[data-hp-prev]'), next = root.querySelector('[data-hp-next]');
  if (prev) prev.addEventListener('click', function () { goTo(current - 1); });
  if (next) next.addEventListener('click', function () { goTo(current + 1); });

  /* ---------- Variants ---------- */
  var variants = [];
  try { variants = JSON.parse(document.querySelector('[data-hp-variants]').textContent); } catch (e) {}
  var form = root.querySelector('[data-hp-form]');
  var idInput = root.querySelector('[data-hp-id]');
  var qtyInput = form.querySelector('input[name="quantity"]');
  var addBtn = root.querySelector('[data-hp-add]');
  var addLabel = root.querySelector('[data-hp-add-label]');
  var optSteps = root.querySelectorAll('[data-hp-opt]');

  function selected() {
    return Array.prototype.map.call(optSteps, function (step) {
      var c = step.querySelector('input:checked');
      return c ? c.value : null;
    });
  }

  function findVariant(opts) {
    return variants.find(function (v) {
      return opts.every(function (val, i) {
        return val === null || v.options[i] === val;
      });
    });
  }

  function currentVariant() { return findVariant(selected()) || variants[0]; }

  /* ---------- Katlyma Bundle Offers (Tiers 1, 2, 3) ---------- */
  
  var offers = root.querySelectorAll('.hp-offer');

  function currentTier() {
    var checked = root.querySelector('input[name="hp-qb"]:checked');
    return checked ? parseInt(checked.value, 10) : 2;
  }

  function paint() {
    var v = currentVariant(); if (!v) return;
    var t = currentTier();
    var totalPrice = 4099;
    if (t === 1) {
      totalPrice = 3499;
    } else if (t === 2) {
      totalPrice = 4099;
    } else if (t === 3) {
      totalPrice = 5999;
    }
    addBtn.disabled = false;
    addLabel.textContent = tr('add_to_cart', 'Add to cart') + ' · ' + money(totalPrice);
  }

  function activateTier(n) {
    offers.forEach(function (off) {
      var isT = off.dataset.hpTier === String(n);
      off.classList.toggle('is-selected', isT);
      var radio = off.querySelector('input[name="hp-qb"]');
      if (radio) radio.checked = isT;
    });

    // Duo inputs enable/disable
    var duoInputs = root.querySelectorAll('.hp-duo-inputs input');
    var singleInputs = root.querySelectorAll('[data-hp-tier-body="1"] input, [data-hp-tier-body="2"] input');
    if (n === 3) {
      duoInputs.forEach(function (i) { i.disabled = false; });
      singleInputs.forEach(function (i) { i.disabled = true; });
    } else {
      duoInputs.forEach(function (i) { i.disabled = true; });
      singleInputs.forEach(function (i) { i.disabled = false; });
    }

    paint();
  }

  offers.forEach(function (off) {
    off.querySelector('.hp-offer__head').addEventListener('click', function () {
      activateTier(+off.dataset.hpTier);
    });
  });

  var UPGRADE_VARIANT_ID = 55422743150935; /* Peaceful Walk Kit Digital Companion - €6.00 */
  var FREE_GUIDE_VARIANT_ID = 55429061411159; /* Peaceful Walks Guide - Free Bonus eBook - €0.00 */

  /* Form submission handler */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var t = currentTier();
    var v = currentVariant();
    if (!v) return;

    addBtn.disabled = true;
    addLabel.textContent = tr('adding', 'Adding to cart…');

    var items = [];
    var noteLines = [];

    if (t === 1) {
      // TIER 1: 1 Harness Standard
      var inputT1 = form.querySelector('[data-hp-tier-body="1"] input[name="properties[Name on patch]"], [data-hp-patch-t1]');
      var nameT1 = (inputT1 ? inputT1.value : '').trim();
      var patchT1 = nameT1 || 'NO CUSTOM NAME (BLANK PATCH)';

      items.push({
        id: parseInt(v.id, 10),
        quantity: 1,
        properties: {
          'Name on patch': patchT1,
          'Package': '1 Harness (Classic)'
        }
      });
      noteLines.push('Sunday Walk Harness [Tier 1]: ' + patchT1);

    } else if (t === 2) {
      // TIER 2: Peaceful Walk Kit (Harness + Guide Companion)
      var inputT2 = form.querySelector('[data-hp-tier-body="2"] input[name="properties[Name on patch]"], [data-hp-patch-t2]');
      var nameT2 = (inputT2 ? inputT2.value : '').trim();
      var patchT2 = nameT2 || 'NO CUSTOM NAME (BLANK PATCH)';

      items.push({
        id: parseInt(v.id, 10),
        quantity: 1,
        properties: {
          'Name on patch': patchT2,
          'Package': 'Peaceful Walk Kit (Includes Ebook & 90-Day Guarantee)'
        }
      });
      items.push({
        id: UPGRADE_VARIANT_ID,
        quantity: 1,
        properties: {
          'Included with': 'Peaceful Walk Kit (' + patchT2 + ')'
        }
      });
      noteLines.push('Sunday Walk Harness [Tier 2 - Peaceful Walk Kit]: ' + patchT2);

    } else if (t === 3) {
      // TIER 3: Duo Family Kit (2 Harnesses + Free Guide)
      var d1NameInp = form.querySelector('input[name="properties[Dog 1 Name]"]');
      var d1Line2Inp = form.querySelector('input[name="properties[Dog 1 Line 2]"]');
      var d2NameInp = form.querySelector('input[name="properties[Dog 2 Name]"]');
      var d2Line2Inp = form.querySelector('input[name="properties[Dog 2 Line 2]"]');

      var d1Name = (d1NameInp ? d1NameInp.value : '').trim() || 'Dog 1 (Blank)';
      var d1Line2 = (d1Line2Inp ? d1Line2Inp.value : '').trim();
      var d2Name = (d2NameInp ? d2NameInp.value : '').trim() || 'Dog 2 (Blank)';
      var d2Line2 = (d2Line2Inp ? d2Line2Inp.value : '').trim();

      var d1Full = d1Name + (d1Line2 ? ' (' + d1Line2 + ')' : '');
      var d2Full = d2Name + (d2Line2 ? ' (' + d2Line2 + ')' : '');

      // Add 2 Harnesses with properties clearly separating Dog 1 and Dog 2
      items.push({
        id: parseInt(v.id, 10),
        quantity: 1,
        properties: {
          'Item': 'Dog 1 Harness',
          'Name on patch': d1Name,
          'Line 2 (Phone)': d1Line2 || 'None',
          'Package': 'Duo Family Pack (2 Dogs)'
        }
      });
      items.push({
        id: parseInt(v.id, 10),
        quantity: 1,
        properties: {
          'Item': 'Dog 2 Harness',
          'Name on patch': d2Name,
          'Line 2 (Phone)': d2Line2 || 'None',
          'Package': 'Duo Family Pack (2 Dogs)'
        }
      });
      // Add FREE Guide eBook
      items.push({
        id: FREE_GUIDE_VARIANT_ID,
        quantity: 1,
        properties: {
          'Included with': 'Duo Family Pack (Free Bonus eBook)'
        }
      });

      noteLines.push('Sunday Walk Harness [Tier 3 - Duo Pack]: Dog 1: ' + d1Full + ' | Dog 2: ' + d2Full);
    }

    // Double redundancy: Save to Cart Note AND add items
    var notePayload = noteLines.join('\n');
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: notePayload })
    }).catch(function () {});

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed: ' + res.status);
      /* Open the slide-out cart on this page instead of leaving for /cart */
      if (window.SPCCart) {
        window.SPCCart.open(true);
        paint();
      } else {
        window.location.href = '/cart';
      }
    }).catch(function (err) {
      console.error('Cart add error:', err);
      form.submit();
    });
  });

  function updateVariant() {
    var o = selected();
    optSteps.forEach(function (step, i) {
      var valEl = step.querySelector('[data-hp-optval]');
      if (valEl && o[i]) valEl.textContent = o[i].replace(' pet ', ' · ');
      
      // Update selected states on size cards
      step.querySelectorAll('.hp-size-card').forEach(function (card) {
        var inp = card.querySelector('input');
        card.classList.toggle('is-selected', inp && inp.checked);
      });

      // Update selected states on color swatches
      step.querySelectorAll('.hp-color-swatch').forEach(function (swatch) {
        var inp = swatch.querySelector('input');
        swatch.classList.toggle('is-selected', inp && inp.checked);
      });
    });

    var v = findVariant(o);
    if (!v) {
      addBtn.disabled = true;
      addLabel.textContent = tr('unavailable', 'Unavailable');
      return;
    }
    idInput.value = v.id;
    addBtn.disabled = !v.available;
    if (!v.available) addLabel.textContent = tr('sold_out', 'Sold out');

    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    history.replaceState(null, '', url.toString());

    // Switch gallery slide to match variant image if available
    for (var i = 0; i < slides.length; i++) {
      var ids = (slides[i].dataset.variantIds || '').split(',');
      if (ids.indexOf(String(v.id)) > -1) { goTo(i); break; }
    }
    paint();
  }

  optSteps.forEach(function (step) {
    step.addEventListener('change', updateVariant);
  });

  // Default initial tier is Peaceful Walk Kit (Tier 2)
  activateTier(2);
  updateVariant();

  /* ---------- Size Guide Trigger ---------- */
  root.querySelectorAll('[data-hp-scroll-sizes]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      var details = document.getElementById('hp-sizes');
      if (details) {
        details.open = true;
        details.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    });
  });

  /* ---------- Show More Reviews Toggle ---------- */
  var moreRevBtn = root.querySelector('[data-hp-more-reviews]');
  var revGrid = root.querySelector('[data-hp-reviews-grid]');
  if (moreRevBtn && revGrid) {
    moreRevBtn.addEventListener('click', function () {
      revGrid.classList.add('is-expanded');
      moreRevBtn.classList.add('is-hidden');
    });
  }

  /* ---------- Scroll to Top / Buy Buttons ---------- */
  root.querySelectorAll('[data-hp-scrolltop]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      e.preventDefault();
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });

  /* ---------- Mobile Sticky Bar Observer ---------- */
  var stickyBar = root.querySelector('[data-hp-sticky]');
  if (stickyBar && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var isPast = !e.isIntersecting && e.boundingClientRect.top < 0;
      stickyBar.classList.toggle('is-visible', isPast);
    }).observe(addBtn);
  }

  var stickyBtn = root.querySelector('[data-hp-sticky-btn]');
  if (stickyBtn) {
    stickyBtn.addEventListener('click', function () {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  /* ---------- Reveal Animations ---------- */
  var revealEls = root.querySelectorAll('.hp-reveal, .hp-sec, .hp-steps li');
  if (!reduceMotion && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  }
})();